import React from "react";

import { Popover, OverlayTrigger } from "react-bootstrap";

const FunnelTooltip = (props) => {
  const { tooltipText, children } = props;

  if (tooltipText && children) {
    return (
      <OverlayTrigger
        placement={"top"}
        trigger={["hover", "focus"]}
        overlay={<Popover id={"popover-positioned-top"}>{tooltipText}</Popover>}
      >
        {children}
      </OverlayTrigger>
    );
  }

  return null;
};

export default FunnelTooltip;
